import React, { memo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useBloc } from '@core/utils/bloc';
import { JobDescriptionWidgetForm, JobDescriptionBlockVariation } from './JobDescriptionBlock';
import { JobDescriptionBlockBloc } from './JobDescriptionBlockBloc';
import { R } from '@core/utils/r';
import { CompactLibraryItemResponse, LibraryItemOptionResponse } from '@business/entities/library';
import { useLibraryItemSelect } from '../Common/LibraryItemSelect';

export interface EmbedBlockSettingsProps {
  form: JobDescriptionWidgetForm;
  variation: JobDescriptionBlockVariation;
}

export const JobDescriptionBlockSettings = memo((props: EmbedBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(JobDescriptionBlockBloc, variation);

  const apply = useCallback(
    (job: CompactLibraryItemResponse, option: LibraryItemOptionResponse) => {
      form.patchValue({ text: job.content as string, heading: option.name, fields: JSON.stringify(R.get(job, 'fields')) });
    },
    [form],
  );

  const { items, onChange, noOptionsMessage } = useLibraryItemSelect(bloc, form.controls.id, 'job descriptions', apply);

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} noOptionsMessage={noOptionsMessage} />
    </div>
  );
});
